// Imported from its own module rather than the ../utils barrel: gatsby-ssr.js
// requires this file at build time, and the barrel would drag every general
// util into the SSR bundle with it.
import { getFormUrl } from '../utils/general/getFormUrl';

export const GATSBY_OPTIMIZELY_PROJECT_ID = process.env.GATSBY_OPTIMIZELY_PROJECT_ID;
export const GATSBY_OPTIMIZELY_ODP_TRACKER_ID = process.env.GATSBY_OPTIMIZELY_ODP_TRACKER_ID;

const optimizelyEvents = {
    SUBMIT_LEAD_TRACKING_FORM: 'submit_lead_tracking_form',
    SUBMIT_LEAD_GENERATION_FORM: 'submit_lead_generation_form',
} as const;

declare global {
    interface Window {
        optimizely?: {
            push: (data: {
                eventName: string;
                type: 'event';
                properties?: {
                    [key: string]: string | number | boolean;
                };
                tags?: {
                    [key: string]: string | number | boolean;
                };
            }) => void;
        };
    }
}

/**
 * Sends the converting page as the `formUrl` custom event property, which must
 * already exist on this event in Optimizely (Implementation > Events) —
 * unrecognized properties are dropped. Same value Pardot receives via
 * `appendFormUrlToExposures`, unencoded here since there are no delimiters to
 * collide with. Omitted when `getFormUrl` returns null so the event still fires.
 * https://support.optimizely.com/hc/en-us/articles/4410288960909-Custom-events
 */
export function trackSubmitLeadTrackingForm() {
    const formUrl = getFormUrl();
    window.optimizely?.push({
        eventName: optimizelyEvents.SUBMIT_LEAD_TRACKING_FORM,
        type: 'event',
        ...(formUrl !== null && { properties: { formUrl } }),
    });
}

export function trackSubmitLeadGenerationForm() {
    window.optimizely?.push({
        eventName: optimizelyEvents.SUBMIT_LEAD_GENERATION_FORM,
        type: 'event',
    });
}
